export default __webpack_public_path__ + "static/aws-banner-ad04f2a4597e7d0563b2bf522ccfd2bd.jpg";